// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"522b362e","75":"a9506828","399":"555eae26","596":"52e1c35c","770":"0d1dd0c0","987":"f4b547f7"}[chunkId] + ".chunk.css";
};